<template>
  <div class="filter-chip-wrap" ref="root">
    <button
      class="filter-chip"
      :class="{ 'filter-chip-active': active }"
      :style="active ? { borderColor: color, background: bgColor, color: color } : {}"
      @click="open = !open"
    >
      <span>{{ active ? selectedLabel : label }}</span>
      <v-icon size="14" :color="active ? color : '#888'" :class="{ 'chev-open': open }">mdi-chevron-down</v-icon>
    </button>

    <div v-if="open" class="filter-menu">
      <button
        v-for="opt in options"
        :key="opt.value"
        class="filter-menu-item"
        :class="{ 'filter-menu-item-active': modelValue === opt.value }"
        @click="select(opt.value)"
      >
        <span>{{ opt.label }}</span>
        <v-icon v-if="modelValue === opt.value" size="14" color="#2E7D32">mdi-check</v-icon>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "FilterChip",
  props: {
    options: { type: Array, required: true },
    modelValue: { default: "all" },
    label: { type: String, default: "Filter" },
    active: { type: Boolean, default: false },
    color: { type: String, default: "#0a1628" },
  },
  emits: ["update:modelValue"],

  data() {
    return { open: false };
  },

  computed: {
    bgColor() {
      // Aus hex eine 8% transparente Variante ableiten
      const hex = this.color.replace("#", "");
      const r = parseInt(hex.substring(0, 2), 16);
      const g = parseInt(hex.substring(2, 4), 16);
      const b = parseInt(hex.substring(4, 6), 16);
      return `rgba(${r},${g},${b},0.08)`;
    },
    selectedLabel() {
      const found = this.options.find((o) => o.value === this.modelValue);
      return found ? found.label : this.label;
    },
  },

  mounted() { document.addEventListener("click", this.handleOutsideClick); },
  beforeUnmount() { document.removeEventListener("click", this.handleOutsideClick); },

  methods: {
    select(value) {
      this.$emit("update:modelValue", value);
      this.open = false;
    },
    handleOutsideClick(e) {
      if (this.open && this.$refs.root && !this.$refs.root.contains(e.target)) {
        this.open = false;
      }
    },
  },
};
</script>

<style scoped>
.filter-chip-wrap { position: relative; }
.filter-chip {
  display: inline-flex; align-items: center; gap: 6px;
  height: 40px; padding: 0 14px;
  background: white; border: 1px solid #eceef2; border-radius: 10px;
  font-size: 12px; font-weight: 600; color: #888;
  cursor: pointer; transition: all 0.15s; font-family: inherit;
}
.filter-chip:hover { border-color: #c5cbd3; color: #0a1628; }
.filter-chip-active { font-weight: 700; }
.chev-open { transform: rotate(180deg); transition: transform 0.2s; }

.filter-menu {
  position: absolute; top: calc(100% + 6px); left: 0; min-width: 200px;
  background: white; border: 1px solid #eceef2; border-radius: 10px;
  box-shadow: 0 12px 32px rgba(10,22,40,0.12);
  z-index: 60; padding: 6px;
  animation: comboFade 0.12s ease;
}
@keyframes comboFade { from { opacity: 0; transform: translateY(-4px); } to { opacity: 1; transform: translateY(0); } }
.filter-menu-item {
  display: flex; align-items: center; justify-content: space-between;
  width: 100%; padding: 8px 10px;
  background: transparent; border: none; border-radius: 7px;
  font-size: 13px; color: #0a1628; font-weight: 500;
  cursor: pointer; transition: background 0.1s; font-family: inherit;
  text-align: left;
}
.filter-menu-item:hover { background: #fafbfc; }
.filter-menu-item-active { background: #fafbfc; font-weight: 700; }
</style>
